import React, { useState, useEffect } from "react";
import { Formik, Field, ErrorMessage, Form, FieldArray } from "formik";
import * as Yup from "yup";
import FieldInput from "../../../CustomComponents/FieldInput";
import ReactSelect from "react-select";
import { ModalBody, ModalFooter } from "reactstrap";
import { useSelector } from "react-redux";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import NumberInputBox from "../../../CustomComponents/AllCustomeInput/NumberInputBox";
import {
  handleKeyDown,
  nomorethenhandread,
  removepresent,
} from "../../../Common/FewCommonMethods";
import { titlevalidation } from "../../../Common/commonvalidation";
import NumberInputBoxDuration from "../../../CustomComponents/AllCustomeInput/NumberInputBoxDuration";
import { Tooltip } from "react-tooltip";
import { penaltytips } from "../../../Common/Tooltips/tooltip";

const ModelMilestones = ({ formData, setFormData, nextPage, setModalMils }) => {
  const penaltylisting = useSelector(
    ({ categary: { penaltylist } }) => penaltylist,
  ) || [];

  const [penaltyInputMode, setPenaltyInputMode] = useState({});

  // Set initial values for the Formik form
  const initialValues = {
    milestones: formData?.milestones || [
      // {
      //   title: "",
      //   duration: "",
      //   duration_type: "",
      //   amount: "",
      //   penalty_id: "",
      //   penalty: "",
      // },
    ],
  };

  // Initialize penaltyInputMode based on initial values
  useEffect(() => {
    const initialMode = {};
    initialValues.milestones.forEach((milestone, index) => {
      if (milestone.penalty_id == 0) {
        initialMode[index] = true; // Set to true if penalty_id is 0 to show input
      } else {
        initialMode[index] = false; // Otherwise show select
      }
    });
    setPenaltyInputMode(initialMode);
  }, []);

  const validationSchema = Yup.object().shape({
    milestones: Yup.array().of(
      Yup.object().shape({
        title: titlevalidation,
        // Add other validations if needed
      }),
    ),
  });

  const handleSubmit = (values) => {
    setFormData((prevData) => ({
      ...prevData,
      ...values,
    }));
    setModalMils((state) => !state);
  };

  const handleProficiencyChange = (selectedOption, index, setFieldValue) => {
    setFieldValue(`milestones[${index}].penalty_id`, selectedOption.value);
    setFieldValue(
      `milestones[${index}].penalty`,
      removepresent(selectedOption.label),
    );
  };

  const handlePenaltyInputChange = (event, index, setFieldValue) => {
    setFieldValue(
      `milestones[${index}].penalty`,
      removepresent(event.target.value),
    );
    setFieldValue(`milestones[${index}].penalty_id`, 0);
  };

  const handleDeadlinetypeChange = (selectedOption, index, setFieldValue) => {
    setFieldValue(`milestones[${index}].duration_type`, selectedOption.value);
  };

  const togglePenaltyMode = (index) => {
    setPenaltyInputMode((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  const durationTypeOptions = [
    { value: 2, label: "Days" },
    { value: 3, label: "Weeks" },
    { value: 4, label: "Months" },
  ];

  return (
    <>
      <button
        onClick={() => setModalMils((state) => !state)}
        className="btn close-button"
      >
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
          alt=""
        />
      </button>
      <ModalBody>
        <h4>Edit Milestones</h4>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {(formik) => (
            <Form>
              <FieldArray name="milestones">
                {({ push, remove }) => (
                  <div className="form-group mb-0">
                    <h6>Add Milestones (Optional)</h6>
                    {formik.values.milestones.map((milestone, index) => (
                      <div
                        key={index}
                        className="mile-flex-cont"
                        style={{ columnGap: "10px" }}
                      >
                        <div className="w-100">
                          <div className="form-group">
                            <FieldInput
                              title={`Milestone ${index + 1} Title`}
                              name={`milestones.${index}.title`}
                              placeholder="Enter milestone title"
                            />
                          </div>
                          <div className="mile-flex">
                            <div className="form-group1">
                              <label>Duration Type</label>
                              <ReactSelect
                                options={durationTypeOptions}
                                placeholder="Select"
                                value={durationTypeOptions.find(
                                  (val) =>
                                    val.value ==
                                    formik.values.milestones[index]
                                      .duration_type,
                                )}
                                onChange={(selectedOption) =>
                                  handleDeadlinetypeChange(
                                    selectedOption,
                                    index,
                                    formik.setFieldValue,
                                  )
                                }
                              />
                              <ErrorMessage
                                name={`milestones.${index}.duration_type`}
                                component="div"
                                className="error"
                              />
                            </div>
                            <div className="form-group1">
                              <NumberInputBoxDuration
                                title={`Duration`}
                                name={`milestones.${index}.duration`}
                                placeholder="Duration"
                                showstar={false}
                              />
                            </div>
                            <div className="form-group1">
                              <NumberInputBox
                                title={`Price in $`}
                                name={`milestones.${index}.amount`}
                                placeholder="Price"
                                showstar={false}
                              />
                            </div>
                            <div className="form-group1">
                              <label>
                                Penalty in % &nbsp;
                                <img
                                  data-tooltip-id="my-tooltip-1"
                                  src={`${CloudStorage.cloudurl}/Assets/Images/common/info-circle.svg`}
                                  alt=""
                                />

                              </label>
                              {penaltyInputMode[index] ? (
                                <input
                                  type="text"
                                  value={
                                    formik.values.milestones[index].penalty
                                  }
                                  onChange={(event) =>
                                    handlePenaltyInputChange(
                                      event,
                                      index,
                                      formik.setFieldValue,
                                    )
                                  }
                                  placeholder="Enter penalty"
                                  onKeyDown={nomorethenhandread}
                                />
                              ) : (
                                <ReactSelect
                                  options={Array.isArray(penaltylisting) ? penaltylisting?.map((penalty) => ({
                                    value: penalty.id,
                                    label: penalty.title,
                                  })) : []}
                                  placeholder="Select"
                                  value={Array.isArray(penaltylisting) ? penaltylisting
                                    .map((penalty_id) => ({
                                      value: penalty_id.id,
                                      label: penalty_id.title,
                                    }))
                                    .find(
                                      (val) =>
                                        val.value == milestone.penalty_id,
                                    ) : []}
                                  onChange={(selectedOption) =>
                                    handleProficiencyChange(
                                      selectedOption,
                                      index,
                                      formik.setFieldValue,
                                    )
                                  }
                                />
                              )}
                              <ErrorMessage
                                name={`milestones.${index}.penalty_id`}
                                component="div"
                                className="error"
                              />
                              <button
                                type="button"
                                onClick={() => togglePenaltyMode(index)}
                                className="buttons border-button mt-1"
                              >
                                {penaltyInputMode[index]
                                  ? "Use Select"
                                  : "Enter manually"}
                              </button>
                            </div>
                          </div>

                        </div>
                        {formik.values.milestones.length > 1 && (
                          <button type="button" onClick={() => remove(index)}>
                            <img
                              src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/delete-icon.svg`}
                              alt=""
                            />
                          </button>
                        )}
                      </div>
                    ))}
                    <button
                      type="button"
                      className="add-more-milestone"
                      onClick={() =>
                        push({
                          title: "",
                          duration: "",
                          duration_type: "",
                          amount: "",
                          penalty_id: "",
                          penalty: "",
                        })
                      }
                    >
                      Add more milestones
                    </button>
                  </div>
                )}
              </FieldArray>
              <ModalFooter>
                <button className="btn" onClick={formik.handleSubmit}>
                  Save
                </button>
              </ModalFooter>
            </Form>
          )}
        </Formik>
        <Tooltip
          id="my-tooltip-1"
          place="bottom"
          content={penaltytips}
        />
      </ModalBody>
    </>
  );
};

export default ModelMilestones;
